export default {"src":"/_next/static/media/email.872960da.svg","height":37,"width":37,"blurWidth":0,"blurHeight":0};